import { render, staticRenderFns } from "./Postulaciones.vue?vue&type=template&id=f4735388"
import script from "./Postulaciones.vue?vue&type=script&lang=js"
export * from "./Postulaciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports